module.exports = __webpack_public_path__ + "static/media/down_arrow.dd116479.svg";